import { Link } from "react-router-dom";
import { Instagram, MapPin } from "lucide-react";
import { CLINIC, INSTAGRAM_URL } from "@/data/content";

const Footer = () => (
  <footer className="bg-deep-sea border-t border-hairline/60 text-cream" data-testid="site-footer">
    <div className="shell pt-16 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <img src="/images/lumiere-logo-light.png" alt="Lumière Aesthetics" className="h-8 w-auto" data-testid="footer-logo" />
          <p className="text-cream/70 text-sm mt-5" data-testid="footer-tagline">Doctor-run aesthetics in Cottesloe.</p>
          <p className="text-cream/70 text-sm">By consultation.</p>
          <p className="text-cream/80 text-sm mt-5">
            <a href={`tel:${CLINIC.phoneTel}`} data-testid="footer-phone-link" className="hover:text-gold transition-colors duration-300">{CLINIC.phone}</a>
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 mt-6 text-cream/70 hover:text-gold text-xs tracking-[0.18em] uppercase transition-colors duration-300"
          >
            <Instagram className="w-4 h-4" strokeWidth={1.25} />
            Instagram
          </a>
        </div>

        <div>
          <p className="text-gold text-[11px] tracking-[0.22em] uppercase mb-5">Visit</p>
          <address className="not-italic text-cream/80 text-sm leading-relaxed">
            {CLINIC.address}
          </address>
          <p className="text-cream/80 text-sm mt-3">
            <a href={`mailto:${CLINIC.email}`} data-testid="footer-email" className="hover:text-gold transition-colors duration-300">{CLINIC.email}</a>
          </p>
          <p className="text-cream/60 text-sm mt-3">{CLINIC.hoursText}</p>
          <p className="text-cream/60 text-sm mt-1">{CLINIC.parking}</p>
          <a
            href="https://maps.google.com/?q=40+Marine+Parade,+Cottesloe+WA+6011"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-map-link"
            className="inline-flex items-center gap-2 mt-3 text-cream/70 hover:text-gold text-xs tracking-[0.14em] uppercase transition-colors duration-300"
          >
            <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />
            Google Maps
          </a>
        </div>

        <div>
          <p className="text-gold text-[11px] tracking-[0.22em] uppercase mb-5">Explore</p>
          <ul className="text-sm space-y-2.5">
            {[
              ["Treatments", "/treatments"], ["Hair Clinic", "/hair"], ["Concerns", "/concerns"], ["The Lumière Team", "/team"], ["The Practice", "/about"],
              ["First Visit", "/first-visit"], ["Pricing", "/pricing"], ["Journal", "/journal"], ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${to.replace(/\//g, "")}`} className="text-cream/80 hover:text-gold transition-colors duration-300">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-gold text-[11px] tracking-[0.22em] uppercase mb-5">Practice</p>
          <ul className="text-sm space-y-2.5">
            {[
              ["Book online", "/book"],
              ["Join the list", "/register"],
              ["Privacy", "/privacy"], ["Complaints", "/complaints"], ["Terms", "/terms"],
              ["Booking & cancellation policy", "/booking-and-cancellation-policy"],
              ["Loyalty terms", "/loyalty"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-cream/80 hover:text-gold transition-colors duration-300">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-cream/15 text-cream/50 text-xs leading-relaxed space-y-2" data-testid="footer-legal-bar">
        <p>
          © 2026 {CLINIC.legal} · ABN {CLINIC.abn} · Trading as Lumière Aesthetics · Imagery may include models
        </p>
        <p data-testid="footer-disclaimer">
          Any surgical or invasive procedure carries risks. Before proceeding, you should seek a second opinion from
          an appropriately qualified health practitioner. The information on this website is general in nature and is
          not medical advice. All new patients require a consultation and suitability assessment; treatments are
          provided only where clinically appropriate. Individual results vary. Services are provided to adults 18
          years and over.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
